import PartnersBadge from "./PartnersBadge";

export default PartnersBadge;
